import { observer } from 'mobx-react-lite';
import React from 'react';

import {
	Icon,
	IconArrowRightArcDots,
	IconBus,
	IconBuses,
	IconCalendar,
	IconClose,
	IconStation,
	IconStationSolid,
} from '@flixbus/honeycomb-icons-react';
import { Tag } from '@flixbus/honeycomb-react';

import { rideFilterStore } from 'pages/RideListPage/components/RideFilters/RideFilterStore';
import { rideListStore } from 'pages/RideListPage/RideListStore';

import { buildFilterChipData } from './buildFilterChipData';

import styles from './styles.module.css';

/** @typedef {import('./buildFilterChipData').FilterType} FilterType */

/** @type {Record<FilterType, JSX.Element>} */
const chipIcons = {
	fromCityIds: <Icon InlineIcon={IconStation} />,
	toCityIds: <Icon InlineIcon={IconStationSolid} />,
	lineIds: <Icon InlineIcon={IconBus} />,
	tripNumbers: <Icon InlineIcon={IconBuses} />,
	runNames: <Icon InlineIcon={IconArrowRightArcDots} />,
	departureRange: <Icon InlineIcon={IconCalendar} />,
};

const FiltersChip = observer(() => {
	const { filtersMap, removeFilter } = rideFilterStore;
	const { isDeadheadsTabActive } = rideListStore;

	const chips = buildFilterChipData({ filtersMap, isDeadheadsTabActive });

	if (chips.length === 0) {
		return null;
	}

	return (
		<div className={styles.tagContainer}>
			{chips.map(({ key, type, label, disabled }) => (
				<Tag extraClasses={styles.tag} display="outlined" key={key} disabled={disabled}>
					{chipIcons[type]}
					{label}
					<Icon
						className={styles.hover}
						InlineIcon={IconClose}
						onClick={() => removeFilter(key)}
						disabled={disabled}
					/>
				</Tag>
			))}
		</div>
	);
});

export default FiltersChip;
